import React from "react";
import { messageController, safeSetMessages } from "./MessageController";
import WhatToDoOptions from "../components/WhatToDo";

const whatToDo = ({ setMessages, onStartStream }) => {
    // Add welcome message
    safeSetMessages(setMessages, (prevMessages) => [
        ...prevMessages,
        {
            sender: "ai",
            content: "Tap the button on your primary device",
            type: "onboarding",
            marginTop: "3em",
        },
    ]);

    // Add demo caption for testing
    // messageController.safeTimeout(() => {
    //     safeSetMessages(setMessages, (prevMessages) => [
    //         ...prevMessages,
    //         {
    //             id: "demo-caption-1",
    //             sender: "caption",
    //             content: "Hej! Jag heter Erik.",
    //             isCaption: true,
    //         },
    //     ]);
    // }, 200);

    // Add the options grid after a short delay
    messageController.safeTimeout(() => {
        safeSetMessages(setMessages, (prevMessages) => [
            ...prevMessages,
            {
                sender: "optionsGrid",
                content: <WhatToDoOptions onStartStream={onStartStream} />,
            },
        ]);
    }, 400);
};

export default whatToDo;
